module.exports = new __parcel__URL__("computerwelt.70a15baa.webp").toString();